import React, {FunctionComponent} from 'react';
import Icons from '../mon-compte/Icons';
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';

interface CartItemStockErrorProps extends TranslationProps {
  className?: string;
  stock: number | null | undefined;
}

const CartItemStockError: FunctionComponent<CartItemStockErrorProps> = ({stock, className, textsContent}) => {
  const isStock = Number(stock) > 0;
  const classCSS1 = 'col-md-1 col-12 d-flex align-items-center itemStockError pa1';
  const classCSS2 = 'justify-content-center flex-wrap text-lg-center text-left w-100'
  return (
    <div
      className={`${className} ${classCSS1} ${classCSS2}`}
      style={{ lineHeight: '1.1em', whiteSpace: 'pre-line' }}
    >
      <div className="display-flex justify-content-center align-items-center">
        <Icons icon="warning" className="align-middle" size={20} fill="#b30000" />
        <div>
          {isStock
            ? textsContent?.['CART_LINE_STOCK_ERROR_NOT_0']?.replace('  ', ` ${stock?.toString() ?? '0'} `)
            : textsContent?.['CART_LINE_STOCK_ERROR_0']
          }
        </div>
      </div>
    </div>
  );
};

export default WithTranslation<CartItemStockErrorProps>(CartItemStockError, 'CART_TUNNEL');
